import wretch from "wretch";
import apiURL from "libs/apiUrl";

const http = wretch(apiURL).options({
	credentials: "include",
	mode: "cors",
});

export default http;
